import { Component, Output, EventEmitter } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  template: `<a href="javascript:void(0)" (click)="onClick()">edit </a>`,
})
export class ProductDetailsLinkComponent implements AgRendererComponent {
  params: any;
  @Output() openModal = new EventEmitter();

  agInit(params: any): void {
    this.params = params;
    // console.log('agInit', this.params.context.componentParent);
  }

  refresh(params: any): boolean {
    return false;
  }

  onClick(): void {
    this.params.context.componentParent.showEditDialog(this.params.data.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ag-grid/product-details-link.component.ts